<template>
    <div class="container">
        <div class="max-w-md">
            <el-card class="bg-white">
                <div class="success-icon mb-6">
                    <el-button type="success" circle size="large">
                        <i class="el-icon-check"></i>
                    </el-button>
                </div>
                <iframe id="cas-iframe" :src="systemInfo.auth_login_out_sso_direct"></iframe>
                <h1 class="text-xl font-bold text-blue-600 mb-4">授权成功</h1>
                <!-- <div class="btn-full">
                    <el-button type="primary" class="w-full" @click="goBack">
                        完成
                    </el-button>
                </div> -->
            </el-card>
        </div>
    </div>
</template>

<script>
import { updScanFirm } from "@/api/common"
export default {
    name: "scanSuccess",
    data() {
        return {
            code_key: '',
            user_data: '',
            systemInfo:{},
        };
    },
    created() {
        // 获取路由参数
        this.code_key = this.$route.query.code_key;
        this.user_data = this.$route.query.user_data;
        console.log("成功页",this.$route.query)
        this.loadObj();
    },
    methods: {
        loadObj() {
            const systemConfig = sessionStorage.getItem("systemConfig") || ""
            const systemInfo = JSON.parse(systemConfig)
            let params = {
                code_key: this.code_key,
                user_data: this.user_data,
            }
            updScanFirm(params).then((response) => {
                if (response.code === 0) {
                    this.systemInfo = systemInfo;
                    console.log(this.systemInfo,"成功", params)
                    // axios.get(systemInfo.auth_login_out_sso_direct)
                }
            }).catch((error) => {  });
        },
    },
};
</script>

<style lang="scss" scoped>
.container {
    width: 100%;
    height: 100%;
    display: flex;
    overflow: hidden;
    background: #eff6ff;
    justify-content: center;
    flex-direction: column;
    #cas-iframe{
      position: fixed;
      top: -9999px;
      left: -9999px;
      width: 1px;
      height: 1px;
      border: none;
    }
    .text-xl {
        text-align: center;
        font-size: 25px;
        color: rgb(37 99 235);
    }

    .max-w-md {
        display: flex;
        flex-wrap: nowrap;
        flex-direction: column;
        justify-content: center;
        width: 90%;
        margin: 0 auto;
    }

    .text-gray {
        text-align: center;
        color: rgb(107 114 128);
    }

    .btn-full {
        text-align: center;

        .w-full {
            background: rgb(37, 99, 235);
            margin-top: 30px;
            width: 60%;
            height: 50px;
        }
    }


    .text-full {
        color: rgb(37, 99, 235);
        margin-top: 15px;
    }
}

/* 自定义样式 */
.el-card {
    border: none;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    border-radius: 10px;
}

.el-button {
    border-radius: 12px;
    padding: 12px 0;
    font-size: 16px;
}

.success-icon {
    display: flex;
    justify-content: center;
}

.success-icon .el-button {
    width: 60px;
    height: 60px;
    font-size: 30px;
}

.info-box {
    background-color: #f5f7fa;
    padding: 16px;
    border-radius: 8px;
}
</style>